const news = [
  {
    path: '/news',
    name: 'News',
    component: () => import('@/views/news'),
    children: [],
    meta: {
      requiresAuth: false
    },
    props: (route) => ({ search: route.params.search })
  },
  {
    path: '/news/:postId',
    name: 'NewsDetails',
    component: () => import('@/views/news/Details'),
    children: [],
    meta: {
      requiresAuth: false
    },
    props: (route) => ({ postId: route.params.postId })
  },
]

export default news